var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-16"},[_c('v-row',[_c('v-col',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"loading":_vm.loading,"headers":_vm.headers,"items":_vm.appeals},on:{"click:row":_vm.handleRowClick}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }